
import React from 'react';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Card, CardContent } from '@/components/ui/card';

interface ProductCurrencyProps {
  currency: string;
  setCurrency: (currency: string) => void;
}

const currencies = [
  { value: 'DZD', label: 'DA - Dinar algérien' },
  { value: 'EUR', label: '€ - Euro' },
  { value: 'USD', label: '$ - Dollar américain' },
  { value: 'GBP', label: '£ - Livre sterling' },
  { value: 'CAD', label: 'CA$ - Dollar canadien' },
  { value: 'CHF', label: 'CHF - Franc suisse' },
  { value: 'AUD', label: 'A$ - Dollar australien' },
  { value: 'JPY', label: '¥ - Yen japonais' },
  { value: 'CNY', label: 'CN¥ - Yuan chinois' },
  { value: 'INR', label: '₹ - Roupie indienne' },
  { value: 'BRL', label: 'R$ - Real brésilien' },
  { value: 'RUB', label: '₽ - Rouble russe' },
  { value: 'KRW', label: '₩ - Won sud-coréen' },
  { value: 'TRY', label: '₺ - Livre turque' },
  { value: 'SAR', label: 'SR - Riyal saoudien' },
  { value: 'AED', label: 'AED - Dirham des Émirats' },
  { value: 'MAD', label: 'MAD - Dirham marocain' },
  { value: 'TND', label: 'TND - Dinar tunisien' },
  { value: 'EGP', label: 'E£ - Livre égyptienne' },
  { value: 'NGN', label: '₦ - Naira nigérian' },
  { value: 'ZAR', label: 'R - Rand sud-africain' },
  { value: 'MXN', label: 'MX$ - Peso mexicain' },
];

const ProductCurrency = ({ currency, setCurrency }: ProductCurrencyProps) => {
  return (
    <Card className="shadow-sm border border-gray-200 dark:border-gray-800">
      <CardContent className="pt-6">
        <div className="space-y-2">
          <Label htmlFor="currency" className="text-gray-700 dark:text-gray-300">Devise</Label>
          <Select value={currency} onValueChange={setCurrency}>
            <SelectTrigger id="currency" className="w-full bg-white dark:bg-gray-800/50 dark:text-gray-200 dark:border-gray-700">
              <SelectValue placeholder="Sélectionner une devise" />
            </SelectTrigger>
            <SelectContent className="max-h-80 dark:bg-gray-800 dark:border-gray-700">
              {currencies.map((curr) => (
                <SelectItem key={curr.value} value={curr.value} className="dark:text-gray-200 dark:focus:bg-gray-700">
                  {curr.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProductCurrency;
